import { RefObject } from 'react'
import useMapHover from '../useMapHover/useMapHover'
import { TooltipDictionary } from '../useMapTooltipContent'
import { CustomOffsets } from '../utils/getRelativeCoordinates'

type UseMapStateHover = {
  svgRef: RefObject<SVGSVGElement>
  containerRef: RefObject<HTMLDivElement>
  tooltips: TooltipDictionary
  customOffsets?: CustomOffsets
  enabled?: boolean
}

function getFormattedId(id: string) {
  const lowerId = id.toLowerCase()

  if (lowerId.startsWith('br-')) {
    return lowerId
  }

  return `br-${lowerId}`
}

function getLabelGroupSelector(formattedId: string) {
  const parts = formattedId.split('-')
  if (parts.length === 2 && parts[0] === 'br') {
    return `[id="${parts[0].toUpperCase()}-${parts[1].toUpperCase()}"]`
  }
  return `[id="${formattedId}"]`
}

const DEFAULT_CUSTOM_OFFSETS: CustomOffsets = {
  'br-ac': { x: -1, y: 1 },
  'br-rj': { x: 0, y: 1 },
  'br-df': { x: 0, y: 1 },
  'br-pe': { x: 0, y: 1 },
  'br-pb': { x: 0, y: 1.2 },
  'br-rn': { x: 0, y: 1 },
  'br-al': { x: 0, y: 1.5 },
  'br-se': { x: 0, y: 1.2 }
}

const useMapStateHover = ({
  svgRef,
  containerRef,
  tooltips,
  customOffsets = DEFAULT_CUSTOM_OFFSETS,
  enabled = false
}: UseMapStateHover) => {
  const { key, tooltipCoordinates } = useMapHover({
    svgRef,
    containerRef,
    tooltips,
    enabled,
    elementSelector: '[id^="BR-"]',
    labelSelector: 'text',
    idFormatter: getFormattedId,
    getLabelGroupSelector,
    customOffsets
  })

  return {
    stateKey: key,
    tooltipCoordinates
  }
}

export default useMapStateHover
